import { render, staticRenderFns } from "./KnowledgeBase.vue?vue&type=template&id=186a953a&scoped=true"
import script from "./KnowledgeBase.vue?vue&type=script&lang=js"
export * from "./KnowledgeBase.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeBase.vue?vue&type=style&index=0&id=186a953a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186a953a",
  null
  
)

export default component.exports